var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArownAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2665 7.25337L7.20654 4.19337C7.08163 4.06921 6.91266 3.99951 6.73653 3.99951C6.56041 3.99951 6.39144 4.06921 6.26653 4.19337C6.20405 4.25535 6.15445 4.32908 6.12061 4.41032C6.08676 4.49156 6.06934 4.5787 6.06934 4.66671C6.06934 4.75471 6.08676 4.84185 6.12061 4.92309C6.15445 5.00433 6.20405 5.07807 6.26653 5.14004L9.3332 8.19337C9.39569 8.25535 9.44528 8.32908 9.47913 8.41032C9.51298 8.49156 9.5304 8.5787 9.5304 8.66671C9.5304 8.75472 9.51298 8.84185 9.47913 8.92309C9.44528 9.00433 9.39569 9.07807 9.3332 9.14004L6.26653 12.1934C6.141 12.318 6.07012 12.4874 6.0695 12.6644C6.06887 12.8413 6.13855 13.0112 6.2632 13.1367C6.38785 13.2622 6.55727 13.3331 6.73418 13.3337C6.91109 13.3344 7.081 13.2647 7.20654 13.14L10.2665 10.08C10.6411 9.70504 10.8514 9.19671 10.8514 8.66671C10.8514 8.13671 10.6411 7.62838 10.2665 7.25337Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArownAcc);
export default __webpack_public_path__ + "static/media/arown-acc.ef4230ea047a1999d45e5903143acb15.svg";
export { ForwardRef as ReactComponent };